/**
 * ShipmentTrackingCode - Código de rastreio destacado com botão copiar (fonte única).
 * Usado no modal da remessa, no cartão Transportadora da O.S. e na listagem.
 *
 * RELEASE: 2026-10-16 v1.0.0 - Extraído do ShipmentDetailsModal.
 */
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

export function ShipmentTrackingCode({ code }: { code: string | null | undefined }) {
  if (!code) return null;
  return (
    <span className="inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      <span className="whitespace-nowrap rounded-md border border-warning/30 bg-warning/10 px-1.5 py-0.5 font-mono text-[11px] text-foreground">{code}</span>
      <Button type="button" size="icon" variant="ghost" className="h-5 w-5" aria-label="Copiar rastreio" title="Copiar rastreio"
        onClick={() => { void navigator.clipboard.writeText(code); toast.success('Rastreio copiado'); }}>
        <Copy className="h-3 w-3" />
      </Button>
    </span>
  );
}
